<template>
  <DefaultPage id="about">
    <div class="about">
      <div class="hero hero-tall">
        <img class="line line-purple-top" src="~@/assets/line-purple-top.png" alt=""/>
        <div class="hero-flex-wrap">
          <div class="grid-container">
              <div class="hero__call">
                <div class="hero-part">
                  <h1
                    class="hero__headline__small"
                    data-aos="fade-right"
                    data-aos-duration="1000"
                  >
                    We protect doctors<br/>so they can move forward.
                  </h1>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="orbs-bg">
        <img class="line line-blue-about-top" src="~@/assets/line-blue-long-swoop-top.png" alt=""/>
        <img class="line line-blue-about-bottom" src="~@/assets/line-blue-long-swoop.png" alt=""/>
        <div
          class="orb purple"
          style="top: 50px; left: -200px;"
        ></div>
        <div
          class="orb blue"
          style="bottom: -150px; right: 50px;"
        ></div>
        <div class="about__content">
          <div
            class="about__intro"
            data-aos="fade-up"
            data-aos-offset="300"
          >
            <div class="grid-container">
              <div class="grid-x align-center">
                <div class="cell small-11 medium-9 large-8 xlarge-7">
                  <p>As a mutual company, each one of our members has a say in how we utilize our resources, provide ongoing education, and protect the best interests of the group as a whole. Physician involvement and physician governance mean that we are able to always keep your interests at heart.</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="our-section our-section--mission"
            data-aos="fade-right"
            data-aos-duration="400"
            data-aos-offset="400"
          >
            <div class="grid-container">
              <div class="grid-x align-center">
                <div class="cell medium-9 large-8">
                  <div class="our-section__content">
                    <p>Our Mission</p>
                    <h5>Protect, support, and advocate for physicians and other healthcare providers.</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="our-section our-section--vision"
            data-aos="fade-left"
            data-aos-duration="400"
            data-aos-offset="400"
          >
            <div class="grid-container">
              <div class="grid-x align-center">
                <div class="cell medium-9 large-8">
                  <div class="our-section__content">
                    <p>Our Vision</p>
                    <h5>To be the premier provider of medical professional liability insurance, education, and support in the markets we serve.</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="our-section our-section--values"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-offset="400"
          >
            <div class="grid-container">
              <div class="grid-x align-center">
                <div class="cell medium-11 large-8">
                  <ValuesMasterDetail/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TheSubFooter />
      </div>
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import ValuesMasterDetail from '@/components/master-detail/ValuesMasterDetail';

export default {
  name: 'About',
  components: {
    ValuesMasterDetail,
    DefaultPage,
    TheSubFooter
  }
};
</script>
